/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_place_the_order = /** @type {(inputs: {}) => string} */ () => {
	return `Objednat`
};

const da_place_the_order = /** @type {(inputs: {}) => string} */ () => {
	return `Afgiv ordre`
};

const de_place_the_order = /** @type {(inputs: {}) => string} */ () => {
	return `Bestellung aufgeben`
};

const en_place_the_order = /** @type {(inputs: {}) => string} */ () => {
	return `Place the order`
};

const es_place_the_order = /** @type {(inputs: {}) => string} */ () => {
	return `Realizar pedido`
};

const fr_place_the_order = /** @type {(inputs: {}) => string} */ () => {
	return `Passer la commande`
};

const hu_place_the_order = /** @type {(inputs: {}) => string} */ () => {
	return `Rendelés leadása`
};

const it_place_the_order = /** @type {(inputs: {}) => string} */ () => {
	return `Effettua l'ordine`
};

const nl_place_the_order = /** @type {(inputs: {}) => string} */ () => {
	return `Bestelling plaatsen`
};

const pl_place_the_order = /** @type {(inputs: {}) => string} */ () => {
	return `Złóż zamówienie`
};

const pt_place_the_order = /** @type {(inputs: {}) => string} */ () => {
	return `Finalizar pedido`
};

const sv_place_the_order = /** @type {(inputs: {}) => string} */ () => {
	return `Slutför beställning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const place_the_order = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.place_the_order(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("place_the_order", locale)
	if (locale === "cs") return cs_place_the_order(inputs)
	if (locale === "da") return da_place_the_order(inputs)
	if (locale === "de") return de_place_the_order(inputs)
	if (locale === "en") return en_place_the_order(inputs)
	if (locale === "es") return es_place_the_order(inputs)
	if (locale === "fr") return fr_place_the_order(inputs)
	if (locale === "hu") return hu_place_the_order(inputs)
	if (locale === "it") return it_place_the_order(inputs)
	if (locale === "nl") return nl_place_the_order(inputs)
	if (locale === "pl") return pl_place_the_order(inputs)
	if (locale === "pt") return pt_place_the_order(inputs)
	return sv_place_the_order(inputs)
};